import React, { useEffect, useState } from 'react';

import {
  IPerguntaRespostaSelecionadas,
  PerguntaQuestionarioMinuta,
  RespostaQuestionarioMinuta,
} from '@app/api/minuta/QuestionarioMinuta';
import { ETipoPerguntaDescricaoId } from '@app/enums/ETipoPerguntaDescricao';
import { Button, Col, FormCheckbox, FormInput, FormRadio, FormSelect, FormTextArea, Row } from '@digital/ui';

import './custom.css';
import { isObjNotEmpty } from '@app/helpers/objHelper';

interface IProps {
  dadosDaPergunta: PerguntaQuestionarioMinuta;
  onPrevStep?: () => void;
  onNextStep?: () => void;
  readonly?: boolean;
  perguntaReadonly?: boolean;
  onGetRespostasQuestionario: (respostas: IPerguntaRespostaSelecionadas[]) => void;
  footer?: boolean;
  footerReadonly?: boolean;
}

export const PerguntaRespostaComponent = ({
  dadosDaPergunta,
  onPrevStep,
  onNextStep,
  readonly = false,
  perguntaReadonly = false,
  onGetRespostasQuestionario,
  footer,
  footerReadonly = false,
}: IProps) => {
  const [pergunta, setPergunta] = useState<PerguntaQuestionarioMinuta>({} as PerguntaQuestionarioMinuta);
  const [respostasSelecionadas, setRespostasSelecionadas] = useState<IPerguntaRespostaSelecionadas[]>([]);

  const [perguntaRespostaSelecionada, setPerguntaRespostaSelecionada] = useState<IPerguntaRespostaSelecionadas>(
    {} as IPerguntaRespostaSelecionadas,
  );

  useEffect(() => {
    setPergunta({} as PerguntaQuestionarioMinuta);
    setPergunta(dadosDaPergunta);

    if (isObjNotEmpty(dadosDaPergunta)) {
      let tempDados = {
        id: dadosDaPergunta.id,
        respostas: [],
        comentario: dadosDaPergunta.comentario,
        isDeAcordo: dadosDaPergunta.isDeAcordo,
        necessitaObservacaoDemandante: dadosDaPergunta.necessitaObservacaoDemandante,
        observacaoDemandante: dadosDaPergunta.observacaoDemandante,
      } as IPerguntaRespostaSelecionadas;

      tempDados = {
        ...tempDados,
        ...([...respostasSelecionadas].find(dados => dados.id == dadosDaPergunta.id) ||
          ({} as IPerguntaRespostaSelecionadas)),
      };

      setPerguntaRespostaSelecionada(tempDados);
    }
  }, [dadosDaPergunta]);

  useEffect(() => {
    if (respostasSelecionadas.length > 0) {
      onGetRespostasQuestionario(respostasSelecionadas);
    }
  }, [respostasSelecionadas]);

  const adicionarRespostaNoArray = (values: IPerguntaRespostaSelecionadas) => {
    let perguntaRespostaSelecionadaTemp = {
      id: perguntaRespostaSelecionada.id,
      respostas: perguntaRespostaSelecionada.respostas,
      comentario: perguntaRespostaSelecionada.comentario,
      isDeAcordo: perguntaRespostaSelecionada.isDeAcordo,
      observacaoDemandante: perguntaRespostaSelecionada.observacaoDemandante,
      necessitaObservacaoDemandante: perguntaRespostaSelecionada.necessitaObservacaoDemandante,
    } as IPerguntaRespostaSelecionadas;

    const tempSemAPerguntaAtual = [...respostasSelecionadas].filter(
      dados => dados.id != perguntaRespostaSelecionada.id,
    );

    if (isObjNotEmpty(values)) {
      if (isObjNotEmpty(values.respostas)) {
        perguntaRespostaSelecionadaTemp.respostas = values.respostas;
      }

      if (values.isDeAcordo != undefined) {
        perguntaRespostaSelecionadaTemp.isDeAcordo = values.isDeAcordo;
      }

      if (values.comentario != undefined) {
        perguntaRespostaSelecionadaTemp.comentario = values.comentario;
      }

      if (values.observacaoDemandante != undefined) {
        perguntaRespostaSelecionadaTemp.observacaoDemandante = values.observacaoDemandante;
      }

      setPerguntaRespostaSelecionada(perguntaRespostaSelecionadaTemp);

      tempSemAPerguntaAtual.push(perguntaRespostaSelecionadaTemp);
      setRespostasSelecionadas([...tempSemAPerguntaAtual]);
    }
  };

  const renderRespostaUnica = (respostas: RespostaQuestionarioMinuta[]) => {
    let respostaRadio: string = '';

    const options = respostas.map(resposta => {
      if (resposta.marcada === true) {
        respostaRadio = resposta.id;
      }

      return {
        value: resposta.id,
        text: resposta.descricao,
      };
    });

    if (
      perguntaRespostaSelecionada.respostas &&
      perguntaRespostaSelecionada.respostas.length == 0 &&
      respostaRadio != ''
    ) {
      adicionarRespostaNoArray({
        id: perguntaRespostaSelecionada.id,
        respostas: [respostaRadio],
      });
    }

    return (
      <FormRadio
        span={12}
        name={'radio' + pergunta.id}
        options={options}
        value={
          (perguntaRespostaSelecionada.respostas && perguntaRespostaSelecionada.respostas.filter(Boolean)[0]) || ''
        }
        disabled={perguntaReadonly || readonly}
        onChange={e => {
          adicionarRespostaNoArray({
            id: perguntaRespostaSelecionada.id,
            respostas: [e.target.value],
          });
        }}
      />
    );
  };

  const renderRespostaMultipla = (respostas: RespostaQuestionarioMinuta[]) => {
    let respostasCheckbox: string[] = [];

    const options = respostas.map(resposta => {
      if (resposta.marcada === true) {
        respostasCheckbox.push(resposta.id);
      }

      return {
        value: resposta.id,
        text: resposta.descricao,
      };
    });

    if (
      perguntaRespostaSelecionada.respostas &&
      perguntaRespostaSelecionada.respostas.length == 0 &&
      respostasCheckbox.length > 0
    ) {
      adicionarRespostaNoArray({
        id: perguntaRespostaSelecionada.id,
        respostas: respostasCheckbox,
      });
    }

    return (
      <FormCheckbox
        span={12}
        name={'check' + pergunta.id}
        options={options}
        value={(perguntaRespostaSelecionada.respostas && perguntaRespostaSelecionada.respostas.filter(Boolean)) || []}
        required={false}
        disabled={perguntaReadonly || readonly}
        onChange={e => {
          adicionarRespostaNoArray({ id: pergunta.id, respostas: e });
        }}
      />
    );
  };

  const renderFooter = () => {
    return (
      <Row>
        <Col span={4}>
          <FormSelect
            label="De Acordo"
            name="isDeAcordo"
            placeholder="Selecione uma opção"
            options={[
              { text: 'Sim', value: '1' },
              { text: 'Não', value: '2' }, //value setado no backend
            ]}
            allowClear
            optionFilterProp="children"
            filterOption={(input: any, item: any) => {
              return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
            }}
            onSelect={(e: any) => {
              adicionarRespostaNoArray({
                id: perguntaRespostaSelecionada.id,
                isDeAcordo: e,
              });
            }}
            value={perguntaRespostaSelecionada.isDeAcordo}
            disabled={footerReadonly || readonly}
          />
        </Col>
        {perguntaRespostaSelecionada.isDeAcordo === '2' && (
          <Col span={8}>
            <FormInput
              label="Comentário"
              name="comentario"
              placeholder="Adicione um comentário"
              onChange={(e: any) => {
                adicionarRespostaNoArray({
                  id: perguntaRespostaSelecionada.id,
                  comentario: e.target.value || '',
                });
              }}
              value={perguntaRespostaSelecionada.comentario}
              disabled={footerReadonly || readonly}
            />
          </Col>
        )}
      </Row>
    );
  };

  const renderObservacao = () => {
    return (
      <Row>
        <Col span={12}>
          <FormTextArea
            name="observacaoDemandante"
            label="Observações"
            rows={1}
            disabled={readonly || perguntaReadonly}
            onChange={(e: any) => {
              adicionarRespostaNoArray({
                id: perguntaRespostaSelecionada.id,
                observacaoDemandante: e.target.value || '',
                necessitaObservacaoDemandante: 'True',
              });
            }}
            value={perguntaRespostaSelecionada.observacaoDemandante}
          />
        </Col>
      </Row>
    );
  };

  const renderRespostaPorTipo = () => {
    if (pergunta.respostas && pergunta.respostas.length > 0) {
      switch (pergunta.tipoPerguntaId) {
        case ETipoPerguntaDescricaoId.RespostaUnica:
          return (
            <>
              {renderRespostaUnica(pergunta.respostas)}
              <Row>{pergunta.necessitaObservacaoDemandante === 'True' && renderObservacao()}</Row>
              <Row>{footer && renderFooter()}</Row>
            </>
          );

        case ETipoPerguntaDescricaoId.RespostaMultipla:
          return (
            <>
              {renderRespostaMultipla(pergunta.respostas)}
              <Row>{pergunta.necessitaObservacaoDemandante === 'True' && renderObservacao()}</Row>
              <Row>{footer && renderFooter()}</Row>
            </>
          );
      }
    }

    return 'Não existe respostas para esta pergunta';
  };

  return (
    <>
      {pergunta && isObjNotEmpty(pergunta) && (
        <div className="perguntaRespostaComponent">
          <h3>{pergunta.pergunta}</h3>
          <Row>{renderRespostaPorTipo()}</Row>

          {onPrevStep && onNextStep && (
            <Row style={{ display: 'flex', justifyContent: 'end' }}>
              <Button onClick={onPrevStep}>Pergunta Anterior</Button>
              <Button onClick={onNextStep}>Próxima Pergunta</Button>
            </Row>
          )}
        </div>
      )}
    </>
  );
};
